import { render, staticRenderFns } from "./ConvertedUser.vue?vue&type=template&id=6a23d81e&"
import script from "./ConvertedUser.vue?vue&type=script&lang=ts&"
export * from "./ConvertedUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports